import React from 'react'; 
import MuiLink from '@mui/material/Link';
import { Link as RouterLink } from 'react-router-dom';
import { linkStyles } from '../../utils/styles';

const CustomLink = React.forwardRef(function CustomLink(props, ref) {
  return (
    <MuiLink
      {...props}
      component={RouterLink}
      sx={linkStyles}
      ref={ref}
      className='link'
    />
  );
});

export default CustomLink;
